import React from "react";
import { Button } from "react-bootstrap";
import { BankHolidayHelper } from "../utils/utils";
import { easterMessage, christmasMessage, mayHolidayMessage } from "../utils/constants";

// BankHolidayMessage component displays an important message regarding the expiry dates kits
const Banner = () => {
  const isBankHoliday = BankHolidayHelper();
  const date = new Date();
  const monthNumber = date.getMonth() + 1;; // 0-indexed, so +1
  const day = date.getDate();
  const mayHolidays = ((monthNumber === 4 && day === 30) || monthNumber === 5);
  let message;

if (monthNumber === 12) {
  message = christmasMessage;
} else if (mayHolidays) {
  message = mayHolidayMessage;
} else {
  message = easterMessage;
}
  if (isBankHoliday) {
    return (
      <div className="bank-holiday-flag">
        <a
          className="flag-a"
          href={mayHolidays ? "https://myhealthchecked.com/bank-holiday-opening-hours" : "https://myhealthchecked.com/myhealthchecked-service-updates"}
          target="_blank"
          rel="noopener noreferrer"
        >
          {message}
        </a>
        <Button
          variant="primary"
          className="read-more-btn"
          href={mayHolidays ? "https://myhealthchecked.com/bank-holiday-opening-hours" : "https://myhealthchecked.com/myhealthchecked-service-updates"}
          target="_blank"
          rel="noopener noreferrer"
        >
          Read More
        </Button>
      </div>
    );
  }

  return null;
};

export default Banner;
